import { routeConst } from 'modules/order/constants';
import { Navigate, useParams } from 'react-router';

export const RedirectToFirstTab = () => {
    const params = useParams<{ orderId: string }>();
    return <Navigate to={`${routeConst.order}/${params.orderId}/${routeConst.orderDetailsTabs.general}`} />;
};
